<ng-run-solution-tree class="solution-tree" [files]="files$ | async"></ng-run-solution-tree>
<div class="project-actions" *ngIf="canEdit$ | async">
  <div class="flex-y-center trigger" (click)="deleteProject()">
    Delete project <svg class="icon-delete ml-1"><use xlink:href="#icon-delete"></use></svg>
  </div>
</div>
